import { Outlet, NavLink, useLocation, useNavigate } from 'react-router-dom';
import Navbar from '@ui/components/Navbar/Navbar';
import BetaBanner from '@ui/components/BetaBanner/BetaBanner';
import AppInstallBanner from '@ui/components/AppInstallBanner/AppInstallBanner';
import BottomTabs from '@ui/components/BottomTabs/BottomTabs';
import { AchievementToast } from '@ui/components/AchievementToast/AchievementToast';
import Footer from '@ui/components/Footer/Footer';
import { usePageTitle } from '../hooks/usePageTitle';
import { ROUTES } from '../../routes';
import { logEvent } from '../../infra/firebase/analytics';
import { AnalyticsEvent } from '../../domain/analytics';
import styles from './AuthenticatedNavbarLayout.module.css';

export default function AuthenticatedNavbarLayout() {
  const pageTitle = usePageTitle();
  const location = useLocation();
  const navigate = useNavigate();
  const isSecondLevel = location.pathname.split('/').filter(Boolean).length > 1;

  return (
    <div className={styles.root}>
      <AppInstallBanner
        onView={() => logEvent(AnalyticsEvent.appBannerView)}
        onCtaClick={() => logEvent(AnalyticsEvent.appBannerClick)}
        onDismiss={() => logEvent(AnalyticsEvent.appBannerDismiss)}
      />
      <BetaBanner
        dismissible
        onView={() => logEvent(AnalyticsEvent.betaBannerView)}
        onDismiss={() => logEvent(AnalyticsEvent.betaBannerDismiss)}
      />
      <Navbar variant="authenticated" />

      {/* Desktop sub-bar: back button + page title on second-level pages */}
      {isSecondLevel && (
        <header className={styles.desktopTopBar}>
          <div className={styles.desktopTopBarInner}>
            <div className={styles.topBarLeft}>
              <button className={styles.backButton} onClick={() => navigate(-1)} aria-label="Go back">
                ←
              </button>
            </div>
          </div>
        </header>
      )}

      {/* Mobile top bar */}
      <header className={styles.mobileHeader}>
        {isSecondLevel ? (
          <button className={styles.mobileBackButton} onClick={() => navigate(-1)} aria-label="Go back">
            ← {pageTitle}
          </button>
        ) : (
          <NavLink to={ROUTES.loggedInHome} className={styles.mobileBrand}>
            <span className={styles.mobileLogo} aria-hidden="true" />
            breath lab
          </NavLink>
        )}
      </header>

      <main className={styles.main}>
        <Outlet />
      </main>

      <Footer />

      <BottomTabs />
      <AchievementToast />
    </div>
  );
}
